import { useMemo } from "react";

/* ---------- helpers ---------- */

function minuteOfDay(d) {
  // backend adds +3h then returns with Z suffix — treat as UTC to get Turkish time index
  return d.getUTCHours() * 60 + d.getUTCMinutes();
}

function buildMinuteLabels(startMinute, length) {
  const out = [];
  for (let i = 0; i < length; i++) {
    const m = startMinute + i;
    const hh = String(Math.floor(m / 60)).padStart(2, "0");
    const mm = String(m % 60).padStart(2, "0");
    out.push(`${hh}:${mm}`);
  }
  return out;
}

/* ---------- hook ---------- */

export function usePastPerformanceSeries({ rawVideo, backwardPrograms }) {
  return useMemo(() => {
    if (!rawVideo || !backwardPrograms || backwardPrograms.length === 0) {
      return { labels: [], seriesSets: [] };
    }

    const parsed = backwardPrograms.map((p) => {
      const start = new Date(p.start_date);
      const end = new Date(p.end_date);

      const startMin = minuteOfDay(start);
      const endMin = minuteOfDay(end);

      const length =
        endMin >= startMin ? endMin - startMin : 1440 - startMin;

      return {
        keyDate: p.key_date,
        startMin,
        length,
      };
    });

    const base = parsed[0];
    const labels = buildMinuteLabels(base.startMin, base.length);

    const seriesSets = parsed.map((p) => {
      // rawVideo keys can be DD-MM-YYYY or YYYY-MM-DD depending on channel
      const dayKeyDDMMYYYY = p.keyDate.split("-").reverse().join("-");
      const dayArr = rawVideo[dayKeyDDMMYYYY] ?? rawVideo[p.keyDate] ?? [];

      const slice = dayArr.slice(p.startMin, p.startMin + p.length);

      // ✅ old system normalization
      const corrected = slice.map((v) =>
        Math.floor((Number(v) || 0) / 2)
      );

      return {
        name: p.keyDate,
        data: corrected,
      };
    });

    return { labels, seriesSets };
  }, [rawVideo, backwardPrograms]);
}
